module.exports = __webpack_public_path__ + "static/img/HUD-Interface-Design.24b640a6.jpg";